export default __webpack_public_path__ + "static/media/nimLi3.eb94c7ab.webp";